import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class BackToTopAPI extends ComponentAPI {
    getMinVisibleHeight() {
        return this.state.minVisibleHeight;
    }
    setMinVisibleHeight(minVisibleHeight) {
        this.setState({ minVisibleHeight });
    }
}
export default BackToTopAPI;
//# sourceMappingURL=back-to-top-api.js.map